document.addEventListener("click", function(e) {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;

  e.preventDefault();
  const targetId = anchor.getAttribute("href").trim();
  if (targetId === "#") return;

  const targetElement = document.querySelector(targetId);
  if (!targetElement) return;

  console.log(targetElement, "targetElement");

  const offset = targetElement.getBoundingClientRect().top + window.scrollY - 150;

  window.scrollTo({
    top: offset,
    behavior: "smooth",
  });
});